import Vue from "vue";
import Router from "vue-router";
import AppLayout from '@/components/appLayout'

Vue.use(Router);
function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}
export default new Router({
  routes: [
    {
      path: "/",
      name: "login",
      // TODO: Change login.vue to Login.vue
      component: loadView("Login"),
      meta: { title: "Login", lang: "mr" }
    },
    {
      path: "/home",
      name: "home",
      component: loadView("Home"),
      meta: { title: "Home" }
    },
    

    {
      path: "/login",
      name: "login",
      // TODO: Change login.vue to Login.vue
      component: loadView("Login"),
      meta: { title: "Login", lang: "mr" }
    },
    {
      path: "/registration",
      name: "registration",
      component: loadView("Registration"),
      meta: { title: "Registration", lang: "mr" }
    },
    {
      path: "/mqlRequestDemo",
      name: "mqlRequestDemo",
      component: loadView("MQLRequestDemo"),
      meta: { title: "MQLRequestDemo" }
    },
    {
      path: "/i18Demo",
      name: "i18Demo",
      component: loadView("I18Demo"),
      meta: { title: "Language Demo" }
    },
    {
      path: "/validator",
      name: "validator",
      component: loadView("Validator"),
      meta: { title: "Validator" }
    },
    {
      path: "/browserCompatibility",
      name: "browserCompatibility",
      component: loadView("BrowserCompatibility"),
      meta: { title: "Browser Compatibility" }
    },
    {
      path: "/encryption",
      name: "encryption",
      component: loadView("Encryption"),
      meta: { title: "Encrypt" }
    },
     


           {
              path: '/layout',
              name: 'layout',
              component: AppLayout,
              children: [
              {
                path: "/dashboard",
                name: "dashboard",
                component: loadView("Dashboard"),
                meta: { title: "Dashboard" }
              },
              {
                path: "/about",
                name: "about",
                component: loadView("About"),
                meta: { title: "About" }
              },
              {
                path: "/attendance-quiz",
                name: "attendanceQuiz",
                component: loadView("AttendanceQuiz"),
                meta: { title: "Attendance Quiz" }
              },
               {
                path: "/webcasts",
                name: "webcasts",
                component: loadView("Webcasts"),
                meta: { title: "Webcasts" }
              },
              {
                path: "/my-plan-for-the-day",
                name: "myplanfortheday",
                component: loadView("MyPlanForTheDay"),
                meta: { title: "MyPlanForTheDay" }
              },
              {
                path: "/rating-self",
                name: "selfratingformyWork",
                component: loadView("SelfRatingForMyWork"),
                meta: { title: "SelfRatingForMyWork" }
              },
              {
                path: "/rating-appraiser",
                name: "ratingappraiser",
                component: loadView("RatingAppraiser"),
                meta: { title: "RatingAppraiser" }
              },
               {
                path: "/reflection",
                name: "reflection",
                component: loadView("Reflection"),
                meta: { title: "Reflection" }
              },
                {
                path: "/profile",
                name: "profile",
                component: loadView("Profile"),
                meta: { title: "Profile" }
              },
              {
                path: "/reports",
                name: "reports",
                component: loadView("Reports"),
                meta: { title: "Reports" }
              },
               {
                path: "/other-references",
                name: "otherreferences",
                component: loadView("OtherReferences"),
                meta: { title: "OtherReferences" }
                },
                {
                  path: "/ratingReports",
                  name: "ratingReports",
                  component: loadView("RatingReports"),
                  meta: { title: "RatingReports" }
                },
                {
                  path: "/studentList",
                  name: "studentList",
                  component: loadView("StudentList"),
                  meta: { title: "Student List" }
                },
                {
                  path: "/industryPartnerList",
                  name: "industryPartnerList",
                  component: loadView("IndustryPartnerList"),
                  meta: { title: "Industry Partner List" }
                },
                {
                  path: "/industryPartnerDisplay/:ipId",
                  name: "industryPartnerDisplay",
                  component: loadView("IndustryPartnerDisplay"),
                  meta: { title: "Industry Partner Details" }
                },
                {
                  path: "/studentDisplay/:mfsId",
                  name: "studentDisplay",
                  component: loadView("StudentDisplay"),
                  meta: { title: "Student Details" }
                },
                {
                  path: "/resetPassword",
                  name: "resetPassword",
                  component: loadView("ResetPassword"),
                  meta: { title: "ResetPassword" }
                }    
              ]
           }
  ]
});
